import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Customer, Department } from '../customer.model';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { MainStore } from 'src/app/common/main.store';
import { CommonService } from 'src/app/services/common.service';
import { CustomerService } from '../customer.service';
import { environment } from 'src/environments/environment';
import { timeout } from 'rxjs';
import { FormsModule } from '@angular/forms';
import { PromotionService } from 'src/app/services/promotion.service';

@Component({
    selector: 'app-customer-copy',
    templateUrl: './customer-copy.component.html',
    styleUrl: './customer-copy.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class CustomerCopyComponent implements OnInit {

  currentDepartment: Department = {} as Department;
  customerId: number = 0;

  environments: string[] = []
  selectedEnvironment: string = '';
  customers: Customer[] = [];
  selectedCustomer: Customer = {} as Customer;

  isSaving: boolean = false;
  loadingCustomers: boolean = true;

  constructor(
    private customerService: CustomerService,
    private promotionService: PromotionService,
    private toastrService: ToastrService,
    public activeModal: NgbActiveModal,
    private store: MainStore,
    private common: CommonService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.currentDepartment = this.store.selectedDepartment.get()!;

    // Kundeopsætningskilden kommer fra API'et — må ikke hardcodes her.
    this.selectedEnvironment = environment.environment;
    this.environments = [this.selectedEnvironment];
    this.promotionService.getEnvironments().then(sources => {
      if (sources.customerSetupSource) {
        this.environments = [sources.current, sources.customerSetupSource];
      }
    });

    this.refreshCustomers();
  }

  async ngOnInit(): Promise<void> {
  }

  save() {
    this.isSaving = true;
    this.customerService.ImportCustomerSetup({
      environment: this.selectedEnvironment,
      sourceCustomerId: this.selectedCustomer.customerId,
      targetCustomerId: this.customerId
    }).then((response) => {
      this.toastrService.success(response.message);
      this.isSaving = false;
      this.common.ImportCompanies.next('refresh');
      this.activeModal.close();
    }
    ).catch((httpError) => {
      this.isSaving = false;
    }
    );
  }

  onEnvironmentChange($event: Event) {
    this.refreshCustomers();
  }

  refreshCustomers() {
    this.loadingCustomers = true;
    this.customerService.getCustomersForEnvironment(this.currentDepartment.id, this.selectedEnvironment)
      .then((response: Customer[]) => {
        if(this.selectedEnvironment == environment.environment) {
          // Fjern nuværende kunde
          response = response.filter(x => x.customerId != this.customerId);
        }
        this.customers = response;
        this.loadingCustomers = false;
        // Sæt til første
        if (this.customers.length > 0) {
          this.selectedCustomer = this.customers[0];
        }
      });
  }
}
